import { z } from "zod";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationReceivedMessagePrivateInsurance.errors.";

const insuranceRegisterSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().nullish(),
  },
  { invalid_type_error: translationPath + "external" },
);

export const privateInsuranceSchema = z.object({
  id: z.string().optional(),
  external: insuranceRegisterSchema,
});

export type TPrivateInsuranceForm = z.infer<typeof privateInsuranceSchema>;
